import { reactAppAws } from "../config/config";

export default reactAppAws;
